
export enum SortOrderCd {
	ASCENDING = 'Ascending',
	DESCENDING = 'Descending'}

